import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { PaymentsPageRoutingModule } from './payments-routing.module';

import { UsfFilteringModalDesktopComponent } from '@shared/components/usf-filtering-modal/usf-filtering-modal-desktop/usf-filtering-modal-desktop.component';
import { UsfFilteringModalMobileComponent } from '@shared/components/usf-filtering-modal/usf-filtering-modal-mobile/usf-filtering-modal-mobile.component';
import { UsfFilteringModalOptionsMobileComponent } from '@shared/components/usf-filtering-modal/usf-filtering-modal-options-mobile/usf-filtering-modal-options-mobile.component';
import { SharedModule } from '../shared/shared.module';
import { AccountBalanceComponent } from './components/account-balance/account-balance.component';
import { AutopayBannerComponent } from './components/autopay-banner/autopay-banner.component';
import { DashboardSelectorModule } from './components/dashboard-selector.module';
import { RecentInvoicesCreditsDesktopComponent } from './components/recent-invoices-credits/desktop/recent-invoices-credits-desktop.component';
import { RecentInvoicesCreditsTouchComponent } from './components/recent-invoices-credits/touch/recent-invoices-credits-touch.component';
import { PaymentsSharedModule } from './payments-shared/payments-shared.module';
import { PaymentsPage } from './payments.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    PaymentsPageRoutingModule,
    SharedModule,
    PaymentsSharedModule,
    DashboardSelectorModule,
  ],
  declarations: [
    PaymentsPage,
    AccountBalanceComponent,
    RecentInvoicesCreditsDesktopComponent,
    RecentInvoicesCreditsTouchComponent,
    UsfFilteringModalDesktopComponent,
    UsfFilteringModalMobileComponent,
    UsfFilteringModalOptionsMobileComponent,
    AutopayBannerComponent,
  ],
})
export class PaymentsPageModule {}
